<template>
  <!-- eslint-disable vue/no-v-html -->
  <div v-editable="blok" :class="modifierClass" v-html="blok.text.content" />
  <!--eslint-enable-->
</template>

<script>
export default {
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
    modifierClass: {
      type: String,
      default: '',
    },
  },
}
</script>
